import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import { useParams, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

let calledTourDetails: any = {}

export const useTour = () => {
  const params = useParams()
  const searchParams = useSearchParams()
  const [loading, setLoading] = useState<boolean>(true)
  const tour = useAppSelector(state => state.tour.tour_details)
  const dispatch = useAppDispatch()

  const tourId = `${params.tourId || ''}`
  const providerCode = searchParams.get('providerCode')
  const priceId = searchParams.get('priceId')
  const isDomestic = searchParams.get('isDomestic')

  useEffect(() => {
    if (!tourId || calledTourDetails[tourId] || !!tour.called) return;
    calledTourDetails = {
      [tourId]: true
    }
    setLoading(true)
    dispatch(thunks.tour_details({
      params: {
        customEndpoint(endpoint) {
          return `${endpoint}/${tourId}`
        },
        price_id: priceId,
        provider_code: providerCode,
        isDomestic,
        search_mode: 1
      }
    })).unwrap().then((res) => {
      setLoading(false)
    }).catch(() => { })
  }, [tourId, providerCode, priceId, isDomestic, tour.called])

  useEffect(() => {
    if (!!tour.data?.departureSchedule?.length) {
      const departureSchedule = tour.data?.departureSchedule[0]
      dispatch(tourActions.selectDepartureSchedule(
        `${departureSchedule.tourId}_${departureSchedule.pricesId}`
      ))
    }
  }, [tour.data])

  return {
    tour,
    loading
  }
}